module.exports = __webpack_public_path__ + "img/aeroplane-transport-svgrepo-com.2012d569.svg";